// TODO: Remove jquery implementations

function isLastTabInGroup($tab, $nextElt) {
  if ($nextElt.length === 0 || !$nextElt.hasClass('js-tab-element')) {
    return true;
  }
  return false;
}

function collectTabGroups($contentTabs) {
  const groups = [];
  let currentGroup = [];

  $contentTabs.each(function () {
    const $tab = $(this);
    const $nextElt = $tab.next();

    currentGroup.push($tab);

    if (isLastTabInGroup($tab, $nextElt)) {
      groups.push(currentGroup);
      currentGroup = [];
    }
  });

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}

export default function accordionTabs(groupCount) {
  const $contentTabs = $('.js-tab-element:not(.tab-pane)');
  if ($contentTabs.length > 0) {
    const isMobile = $('.js-toggle-navigation').is(':visible');
    const tabGroups = collectTabGroups($contentTabs);

    tabGroups.forEach((groupTabs, groupIndex) => {
      if (groupTabs.length === 0) {
        return;
      }

      if (isMobile) {
        const $outerContainer = $('<div class="frame rte grid-accordion frame-default frame-layout-0 mb-medium"></div>');
        const $container = $('<div class="o-accordion ba-accordion"></div>');
        $outerContainer.append($container);
        groupTabs[0].before($outerContainer);

        groupTabs.forEach(($tab) => {
          const itemId = $tab.data('id');
          let header = $tab.data('tabTitle') || $tab.find('h1:first,h2:first,h3:first,h4:first').first().text().trim();
          if (!header) {
            header = `${$tab.text().trim().substring(0, 10)}...`;
          }

          const itemHtml = `<h5 class="o-accordion__trigger collapsed" id="trigger-${itemId}" data-toggle="collapse" data-target="#container-${itemId}" aria-expanded="false" aria-controls="c${itemId}">`
            + `<span class="css-plusminus" data-filterbar-trigger-icon=""></span>${header}</h5>`
            + `<div id="container-${itemId}" class="collapse" aria-labelledby="trigger-${itemId}" data-parent="#trigger-${itemId}">`
            + `<div class="m-accordion-item">${$tab.html()}</div>`
            + '</div>';

          $tab.addClass('o-accordion__item');
          $tab.html(itemHtml);
          $tab.find('header').first().addClass('d-none d-lg-block');
          $container.append($tab);
        });

        return;
      }

      const currentGroupCount = groupCount + groupIndex;
      const $container = $('<div class="o-tabs"></div>');
      const $navTabs = $(`<div class="nav nav-tabs" id="nav-tabs-${currentGroupCount}" role="tablist"></div>`);
      const $nav = $('<nav class="o-tabs__nav"></nav>');
      const $tabContent = $(`<div class="tab-content mb-5" id="tab-content-${currentGroupCount}"></div>`);

      $nav.append($navTabs);
      $container.append($nav);
      $navTabs.css('opacity', 0);
      $container.append($tabContent);
      groupTabs[0].before($container);

      groupTabs.forEach(($tab, itemCount) => {
        const itemId = $tab.data('id');
        let header = $tab.data('tabTitle') || $tab.find('h1:first,h2:first,h3:first,h4:first').first().text().trim();
        if (!header) {
          header = `${$tab.text().trim().substring(0, 10)}...`;
        }

        const itemHtml = `<a class="nav-item nav-link${itemCount < 1 ? ' active' : ''}" id="nav-tab-${itemId}"`
          + ` data-toggle="tab" href="#${$tab.attr('id')}" role="tab" aria-controls="c${$tab.attr('id')}" aria-selected="true">${header}</a>`;

        $navTabs.append(itemHtml);
        $tab.addClass(`tab-pane fade${itemCount < 1 ? ' active show' : ''}`);
        $tab.attr('role', 'tabpanel');
        $tab.attr('aria-labelledby', `nav-tab-${itemId}`);
        $tabContent.append($tab);
      });

      $navTabs.animate({
        opacity: 1.0,
      }, 350);
    });

    if (!isMobile) {
      const nextGroupCount = groupCount + tabGroups.length;
      if ($('.js-tab-element:not(.tab-pane)').length > 0) {
        accordionTabs(nextGroupCount);
      }
    }
  }
}
